import { AssignableSubscriptionOption } from '@localstack/types';
import { ProgressButton } from '@localstack/ui';
import { Box, Select, SelectChangeEvent, MenuItem } from '@mui/material';
import { ReactElement } from 'react';

import { LicenseAssignmentPlanLabel } from '~/components/MembersAndLicenses/LicenseAssignmentPlanLabel';

export const SelfAssignDropdown = ({
  options,
  selectedSubscriptionId,
  onChangeSelection,
  onSubmit,
  isSubmitting,
}: {
  options: AssignableSubscriptionOption[];
  selectedSubscriptionId: string;
  onChangeSelection: (subscriptionId: string) => void;
  onSubmit: () => void;
  isSubmitting: boolean;
}): ReactElement => (
  <Box display="flex" flexDirection="row" gap={1} alignItems="center">
    <Select
      size="small"
      displayEmpty
      value={selectedSubscriptionId}
      onChange={(event: SelectChangeEvent) => onChangeSelection(event.target.value)}
      sx={{ minWidth: 220 }}
    >
      <MenuItem value="" disabled>
        Select a subscription
      </MenuItem>
      {options.map((option) => (
        <MenuItem key={option.subscription_id} value={option.subscription_id}>
          <LicenseAssignmentPlanLabel emulator={option.emulator} family={option.plan_family} />
        </MenuItem>
      ))}
    </Select>
    <ProgressButton
      variant="outlined"
      size="small"
      color="primary"
      style={{ whiteSpace: 'nowrap' }}
      disabled={!selectedSubscriptionId}
      onClick={onSubmit}
      loading={isSubmitting}
    >
      Assign license
    </ProgressButton>
  </Box>
);
